module.exports = __webpack_public_path__ + "images/2x4-billboard-54986e5c165cc2465eddd84c288c1375.jpg";